import React from 'react';
import * as S from './HeaderNav.styles';

import IconSelector from '@ibibo/icon-selector';

const HeaderNav = ({headers, activeTab, updateActiveTab}) => {
  return(
    <S.HeaderNavOuterWrap>
      <S.HeaderInnerWrap>
        <S.HeaderNavWrap>
          {headers.map(header => <S.HeaderNavWrapInner key={header.heading} active={activeTab === header.icon} onClick={() => {
            updateActiveTab(header.icon);
          }}>
            <S.NavIconWrap>
              <IconSelector iconKey={`${header.icon}${activeTab === header.icon ? 'active' : ''}`} />
            </S.NavIconWrap>
            <S.HeaderNavTextWrap>
              <S.HeaderNavMainText>{header.heading}</S.HeaderNavMainText>
            </S.HeaderNavTextWrap>
          </S.HeaderNavWrapInner>)}
        </S.HeaderNavWrap>
      </S.HeaderInnerWrap>
    </S.HeaderNavOuterWrap>
  );
}

export default HeaderNav;